import * as envivo from "@envivo/backoffice-components/_core/auth/auth";

const auth = envivo;

export const $eventbus = auth.$eventbus;
export default auth.default;
